import { BiMobileVibration } from "react-icons/bi";
import { CgWebsite } from "react-icons/cg";
import { FaDesktop } from "react-icons/fa";
import "./services.css";

export default function Services() {
  return (
    <section className="service" id="services">
      <div className="container">
        <header className="serviceTitle">
          <h2 className="titleHead">My Services</h2>
          <p className="titleDoc">What I Provide</p>
        </header>

        <div className="serviceItem">
          <article
            className="serviceList"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            <CgWebsite className="servicesIcon" />
            <h3 className="serviceListTitle">Web Design</h3>
            <p>
              I create custom websites for businesses, portfolios, blogs,
              e-commerce, and more — visually stunning, user-friendly, and
              cleanly designed for an optimal experience.
            </p>
          </article>

          <article
            className="serviceList"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <BiMobileVibration className="servicesIcon" />
            <h3 className="serviceListTitle">Site Optimization</h3>
            <p>
              I improve your website’s loading speed and performance, enhancing
              SEO rankings and user satisfaction through smart optimization
              techniques.
            </p>
          </article>

          <article
            className="serviceList"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <FaDesktop className="servicesIcon" />
            <h3 className="serviceListTitle">Web Development</h3>
            <p>
              I develop scalable and secure websites from scratch — focused on
              performance, functionality, and maintaining future-ready code.
            </p>
          </article>
        </div>
      </div>
    </section>
  );
}
